module.exports = __webpack_public_path__ + "static/media/item-5.2e746b95.png";